import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import TutorialPlaylistCreateForm from "./create";
import TutorialPlaylistEditForm from "./edit";
import { TutorialPlaylistDto } from "src/store/tutorials/type";
import {
  deleteTutorialPlaylistSaga,
  getTutorialPlaylistDetailsSaga,
  getTutorialPlaylistsSaga,
} from "src/store/tutorials/saga";

const TutorialsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<TutorialPlaylistDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<TutorialPlaylistDto & { Translates?: any[] }>();

  const columns = [
    { text: t("Tutorials.ModuleKey"), dataField: "ModuleKey" },
    { text: t("Tutorials.Title"), dataField: "Title" },
    { text: t("Tutorials.VideosCount"), dataField: "VideosCount" },
    { text: t("Tutorials.Order"), dataField: "Order" },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("TutorialVideos.PageTitle")}
        metaTag={t("TutorialVideos.PageTitle")}
        gridProps={{
          addTitle: t("Tutorials.AddPlaylist").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getTutorialPlaylistsSaga,
          onCreateClick: () => setShowCreate(true),
          // "Videolar" — playlist videolarını yönet.
          detailButton: {
            onClick: (id: string) => navigate("/tutorials/videos/" + id),
          },
          editButton: {
            onClick: (id: string) => {
              dispatch(
                getTutorialPlaylistDetailsSaga({
                  id,
                  payload: {
                    onSuccess: (_m: string, payload: any, response: any) => {
                      const obj = payload;
                      obj.Translates = response.Translates;
                      setSelected(obj);
                      setShowEdit(true);
                    },
                    onError: () => {},
                  },
                })
              );
            },
          },
          deleteButton: {
            text: (_id: string, row: TutorialPlaylistDto) =>
              t("Tutorials.DeletePlaylistConfirm", { name: row.Title }).toString(),
            action: deleteTutorialPlaylistSaga,
            onClick: () => {},
          },
        }}
      />
      <TutorialPlaylistCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch,
            message: m,
            action: getTutorialPlaylistsSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <TutorialPlaylistEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch,
              message: m,
              action: getTutorialPlaylistsSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default TutorialsPage;
